// Copyright (c) 2020 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Accordion from '../../../shared/components/smart-accordion/state/accordion';
import AdvanceSearchAccordion from './advance-search-rga';
import ReportLinks from '../../../shared/components/report-links';
import SearchBox from '../../../shared/components/search-box';
import SearchByDropDown from '../state/search-by-dropdown';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import SupportPanel from './support-panel';
import UsefulLinksPanel from './useful-links-panel';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function handleOnMassUpdate() {

    this.actions.openMassUpdateModal();

}

function handleOnMassUpload() {

    this.actions.openMassUploadModal();

}

function handleSearchByDownDropDown(key) {

    this.actions.updateSearchByDropDown(key);
    this.actions.updateSearchQueryString('');

    this.actions.resetRgaSearchModelObject();
    this.actions.resetRgaSearchSelectedDomains();

}
function onChangeFormFieldListValue(value) {

    const valueList = value ? value.split(',') : [];

    this.actions.updateSearchQueryString(value);

    const keyToFieldMap = {
        ANALYST: 'analystIds',
        ENGINE_SN: 'engineSerialNumbers',
        MACHINE_PIN: 'machineSerialNumbers',
        PART_NUMBER: 'partNumbers',
        RGA_NUMBER: 'rgaNumbers',
        WARRANTY_CLAIM: 'warrantyClaimNumbers'
    };

    const field = keyToFieldMap[this.searchByDropDown.selectedOption.key];

    if (field) {

        this.actions.updateRgaSearchObject(field, valueList);

    }

}
function mapSearchPlaceHolder(key) {

    const map = {
        ANALYST: 'Search RGA By Analyst',
        ENGINE_SN: 'Search RGA By Engine SN',
        MACHINE_PIN: 'Search RGA By Machine PIN',
        PART_NUMBER: 'Search RGA By Part Number',
        RGA_NUMBER: 'Search RGA By RGA Number',
        WARRANTY_CLAIM: 'Search RGA By Warranty Claim'
    };

    const mapKey = map[key] || '';

    return mapKey;

}

function toggleReportsAccordion() {

    this.setState({
        reportsAccordion: {
            ...this.state.reportsAccordion,
            isExpanded: !this.state.reportsAccordion.isExpanded
        }
    });

}
class RgaWip extends Component {

    constructor(props) {

        super(props);
        this.accordion = new Accordion({
            accordionId: 'RGA_BO_REPORTS',
            isExpanded: false
        });
        this.state = {
            reportsAccordion: this.accordion
        };

    }

    componentWillMount() {

        this.props.actions.getRgaUnitsDropDown();
        this.props.actions.getRgaStatusDropDown();
        this.props.actions.getRgaRequestorTypeDropDown();
        this.props.actions.getRgaAnalysisStatusDropDown();

    }

    render() {

        return (
            <section className='rga-wip'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='rga-homepage-aside'>
                    <UsefulLinksPanel
                        onMassUpdate={this.props::handleOnMassUpdate}
                        onMassUpload={this.props::handleOnMassUpload}
                        security={this.props.security}
                    />
                    <SupportPanel/>
                    <div className='report-links'>
                        <ReportLinks
                            accordion={this.state.reportsAccordion}
                            onAccordionToggle={this::toggleReportsAccordion}
                            parentRoute='rga'
                            routes={this.props.reportsRoutes}
                        />
                    </div>
                </aside>
                <main className='rga-homepage-main'>
                    <SearchBox
                        defaultOption={this.props.searchByDropDown.selectedOption.key}
                        onOptionChange={this.props::handleSearchByDownDropDown}
                        onQueryChange={this.props::onChangeFormFieldListValue}
                        onSearch={this.props::handleSearch}
                        placeholderText={mapSearchPlaceHolder(this.props.searchByDropDown.selectedOption.key)}
                        queryString={this.props.searchQueryString}
                        searchBy={this.props.searchByDropDown.searchBy}
                    />
                    <h3 className='inlineInfoMessage'>{'Use \'commas\' to separate values in multiple RGA searches'}</h3>

                    <div className='rga-advanced-search'>
                        <AdvanceSearchAccordion/>
                    </div>
                </main>
            </section>

        );

    }

}

RgaWip.displayName = 'RgaWip';
RgaWip.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default RgaWip;



// WEBPACK FOOTER //
// ./src/rga/search/components/index.js